import { useEffect, useState } from "react";
import HookForm from "../../../components/HookForm/HookForm";
import getContainerCard from "../../../api/containers/getContainerCard";
import { useParams } from "react-router-dom";
import alert from "../../../helpers/alert";
import SelectMarks from "../../../components/Selects/SelectMarks";
import SelectModels from "../../../components/Selects/SelectModels";
import DocsInputNew from "../../../components/Inputs/DocsInput/DocsInputNew";
import editContainer from "../../../api/containers/editContainer";
import Header from "../../../components/Header/Header";
import formatNumber from "../../../utils/formatNumber";
import ContainerColorPhotos from "./ContainerColorPhotos";
const formStyles = {
    carInfo: { display: 'grid', gap: '20px', gridTemplateColumns: `1fr 1fr 1fr 1fr` },
    dealerInfo: { display: 'grid', gap: '20px', gridTemplateColumns: '1fr 1fr' },
    other: { display: 'grid', gap: '20px' },
  };
  
const CarContainerEdit = () => {
    const { id } = useParams();
    const [loading, setLoading] = useState(false)
    const [data, setData] = useState([]);

      const save = async (values) => {
        setLoading(true)
        try {
            await editContainer({
                containerId: id,
                photo: values?.photo,
                customPrice: values?.customPrice
            });
            alert.success("ÐÐ·Ð¼ÐµÐ½ÐµÐ½Ð¸Ñ ÑÑÐ¿ÐµÑÐ½Ð¾ ÑÐ¾ÑÑÐ°Ð½ÐµÐ½Ñ")
            update();
        } catch(e) {
            alert.error(e)
        } finally {
            setLoading(false)
        }
      }

      const update = async () => {
        setLoading(true)
        try {
            const res = await getContainerCard({ id });
            const container = res?.data?.container;

            setData([
                {
                    name: 'mark',
                    component: SelectMarks,
                    label: 'ÐÐ°ÑÐºÐ°',
                    placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°',
                    defaultValue: { value: container?.mark?.id, label: container?.mark?.name },
                    disabled: true,
                  },
                  {
                    name: 'model',
                    component: SelectModels,
                    dependency: 'mark',
                    dependencyAccessor: (obj) => obj?.value,
                    label: 'ÐÐ¾Ð´ÐµÐ»Ñ',
                    placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°',
                    defaultValue: { value: container?.model?.id, label: container?.model?.name },
                    disabled: true,
                  },
                  {
                    name: 'customPrice',
                    label: 'Ð¦ÐµÐ½Ð° Ð¾Ñ',
                    placeholder: 'Ð£ÐºÐ°Ð¶Ð¸ÑÐµ Ð¼Ð¸Ð½Ð¸Ð¼Ð°Ð»ÑÐ½ÑÑ ÑÐµÐ½Ñ',
                    format: 'number',
                    defaultValue: formatNumber(container?.customPrice),
                  },
                  {
                    name: 'photo',
                    component: DocsInputNew,
                    label: 'Ð¤Ð¾ÑÐ¾',
                    text: 'Ð¤Ð¾ÑÐ¾',
                    id: Math.random(),
                    showImage: true,
                    imageUrl: container?.url,
                  }
            ])
        } catch(e) {
            alert.error(e);
        } finally {
            setLoading(false)
        }
      }

      useEffect(() => {
        update();
      }, [])

    return(<>
        <Header title="Ð ÐµÐ´Ð°ÐºÑÐ¸ÑÐ¾Ð²Ð°ÑÑ Ð¼Ð°ÑÐºÑ Ð¸ Ð¼Ð¾Ð´ÐµÐ»Ñ" />
        <HookForm inputs={data} border grid={formStyles.carInfo} onSubmit={save} loading={loading} action="Ð¡Ð¾ÑÑÐ°Ð½Ð¸ÑÑ Ð¸Ð·Ð¼ÐµÐ½ÐµÐ½Ð¸Ñ" />
        <ContainerColorPhotos containerId={id} />
    </>)
}

export default CarContainerEdit;